import Vue from 'vue'

export const ErrorPage = Vue.component(
  'ErrorPage',
  require('_/components/ErrorPage/ErrorPage.vue').default
)

export const InvalidLicense = Vue.component(
  'InvalidLicense',
  require('_/components/InvalidLicense/InvalidLicense.vue').default
)

export const ApiCallsExceeded = Vue.component(
  'ApiCallsExceeded',
  require('_/components/ApiCallsExceeded/ApiCallsExceeded.vue').default
)

export const Login = Vue.component(
  'Login',
  require('_/components/Authentication/Login/Login.vue').default
)

export const SocialLogin = Vue.component(
  'SocialLogin',
  require('_/components/Authentication/SocialLogin/SocialLogin.vue').default
)

export const Register = Vue.component(
  'Register',
  require('_/components/Authentication/Register/Register.vue').default
)

export const Registered = Vue.component(
  'Registered',
  require('_/components/Authentication/Register/Registered.vue').default
)

export const EmailConfirmation = Vue.component(
  'EmailConfirmation',
  require('_/components/Authentication/Register/EmailConfirmation.vue').default
)

export const EmailChangeConfirmation = Vue.component(
  'EmailChangeConfirmation',
  require('_/components/Authentication/Register/EmailChangeConfirmation.vue')
    .default
)

export const ForgotPassword = Vue.component(
  'ForgotPassword',
  require('_/components/Authentication/ForgotPassword/ForgotPassword.vue')
    .default
)

export const ConfirmReset = Vue.component(
  'ConfirmReset',
  require('_/components/Authentication/ForgotPassword/ConfirmReset.vue').default
)

export const SetNewPassword = Vue.component(
  'SetNewPassword',
  require('_/components/Authentication/ForgotPassword/SetNewPassword.vue')
    .default
)

export const PasswordReset = Vue.component(
  'PasswordReset',
  require('_/components/Authentication/ForgotPassword/PasswordReset.vue')
    .default
)

export const Dashboard = Vue.component(
  'Dashboard',
  require('_/components/Dashboard/Dashboard.vue').default
)

export const Admin = Vue.component(
  'Admin',
  require('_/components/Admin/Admin.vue').default
)

export const Generator = Vue.component(
  'Generator',
  require('_/components/Generator/Generator.vue').default
)

export const MenuEditor = Vue.component(
  'MenuEditor',
  require('_/components/MenuEditor/MenuEditor.vue').default
)

export const MenuItemsEditor = Vue.component(
  'MenuItemsEditor',
  require('_/components/MenuItemsEditor/MenuItemsEditor.vue').default
)

export const Notifications = Vue.component(
  'Notifications',
  require('_/components/Notifications/Notifications.vue').default
)
